import React from 'react'

function Press() {
  return (
    <div>Press</div>
  )
}

export default Press